/**
 * Created by Andrey on 21.10.2026.
 */

// Sessions that start at the first levels long after the install. A farm relaunches the game for days and never gets past
// the tutorial: the fairy android ghosts of 09.2026 sat at level 0-1 for their whole life (85% still at level 0 on day 3),
// while a player who comes back an hour after the install is past level 1 (fairy: 7 minutes of play to level 3). A session
// at a higher level resets
class LowLevelSessionsFraud extends cleverapps.EventEmitter {
    constructor() {
        super();

        this.config = {
            threshold: 3
        };

        connector.metrics.on("startSession", () => this.onStartSession());
    }

    onStartSession() {
        if (connector._metrics.session === 0) {
            return;
        }

        const level = ["merge", "merge2"].includes(cleverapps.config.type)
            ? cleverapps.gameLevel.level
            : cleverapps.user.getHumanReadableNumber() - 1;

        this.trigger(level <= 1 ? "hit" : "reset");
    }
}
